'use client';

import type { PackagePricingPlansContent } from '@/core/types';

import React from 'react';

import { PackagePricingPlans } from '@/containers/blocks/features';

export default function PackagePricingPlansGenerator({
  content,
  className,
}: {
  content: PackagePricingPlansContent;
  className?: string;
}) {
  return (
    <PackagePricingPlans
      title={content?.title}
      subtitle={content?.subtitle}
      durations={content?.durations}
      button={content?.button}
      packages={content?.packages}
      className={className}
    />
  );
}
